export const getUniqueFavoriteListName = (listName: string, listNames: string[]) => {
  const name = listName.trim()
  const nameExists = listNames.includes(name)
  if (!nameExists) {
    return name
  }

  const nameWithNumber = `${name}, 1`
  if (!listNames.includes(nameWithNumber)) {
    return nameWithNumber
  }

  const nameRegex = new RegExp(`^${name},\\s(\\d+)$`)
  const nameNumbers = listNames
    .filter(list => nameRegex.test(list))
    .map(list => Number(list.match(nameRegex)?.[1]))
  const nextNameNumber = Math.max(...nameNumbers, 0) + 1

  return `${name}, ${nextNameNumber}`
}
